import React from "react"
import OrgAdmin from "components/Organizations/ManageOrganizations"

const OrganizationAdmin = () => {
  return (
      <OrgAdmin/>
  );
};
export default OrganizationAdmin;
